import { useIntl } from 'react-intl'

import {
  isAuctionListing,
  isOfferingListing,
  isFulfillmentListing,
  isInvoiceSpotListing,
} from '@b-stock/fe-core/bstock-next/queries'

import { ErrorBannerComponent } from '@/buyer-portal/components/ErrorBanner'
import { type ListingDetails } from '@/queries/listingDetailsQuery'

export const ListingTypeGuard = ({
  listing,
  children,
}: {
  listing: ListingDetails
  children: React.ReactNode
}) => {
  const isValidListingType =
    isOfferingListing(listing) ||
    isFulfillmentListing(listing) ||
    isAuctionListing(listing) ||
    isInvoiceSpotListing(listing)

  const { formatMessage } = useIntl()
  if (!isValidListingType) {
    return (
      <ErrorBannerComponent
        errorMessage={formatMessage({
          id: 'Listing.errors.invalidListingType',
        })}
      />
    )
  }

  return children
}
